import React, { useMemo } from "react";
import styles from "./Style.module.css";
import useDocTable from "./DocTable.hook";
import constants from "../../../../../config/constants";
import DataTables from "../../../../../Datatables/Datatable.table";
import { Typography } from "@mui/material";
import ShadowBox from "../../../../../components/ShadowBox/ShadowBox";

const DocTable = ({ programId, renderList }) => {
  const {
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    isCalling,
    data,
    currentData,
    currentPage,
    isFetching,
  } = useDocTable({ programId, renderList });

  const tableStructure = useMemo(() => {
    return [
      {
        key: "doc_code",
        label: "MyDoc Code",
        sortable: false,
        render: (temp, all) => (
          <div>
            {all?.code}
          </div>
        ),
      },
      {
        key: "doc_name",
        label: "Doctor Name",
        sortable: false,
        render: (temp, all) => <div>{all?.doctor?.name}</div>,
      },

      {
        key: "code_doc",
        label: "Doctor Code",
        sortable: false,
        render: (temp, all) => <div>{all?.doctor_code}</div>,
      },
    ];
  }, [isCalling]);

  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
    };

    const datatable = {
      ...constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: currentData,
      count: data.length,
      page: currentPage - 1,
      rowsPerPage: 10,
      allRowSelected: false,
      showSelection: false,
    };

    return { datatableFunctions, datatable };
  }, [
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    currentData,
    currentPage,
    data,
  ]); // allData,

  return data?.length > 0 ? (
    <ShadowBox className={styles.product}>
      <div className={styles.mainContainer}>
        <div className={styles.row1}>
          <Typography
            variant={"h5"}
            className={styles.productHeading}
            color={"text.primary"}
          >
            {" "}
            MyDoc Code Details
          </Typography>
        </div>
        <br />
        <DataTables
          {...tableData.datatable}
          {...tableData.datatableFunctions}
        />
      </div>
    </ShadowBox>
  ) : (
    <></>
  );
};

export default DocTable;
